module.exports = __webpack_public_path__ + "img/logo.d71ede6b.png";